import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data1jasy19j4j968 as Data } from '../DeletePinMutation.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.u6i_1 = listOf('deletePin');
      }
      s3x(reader, customScalarAdapters) {
        var _deletePin = null;
        $l$loop: while (true) {
          if (reader.p4c(this.u6i_1) === 0)
            _deletePin = get_NullableBooleanAdapter().s3x(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_deletePin);
      }
      v6i(writer, customScalarAdapters, value) {
        writer.n4a('deletePin');
        get_NullableBooleanAdapter().x3x(writer, customScalarAdapters, value.u6e_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.v6i(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance2uoaydfs2alvj,
};
//endregion

//# sourceMappingURL=DeletePinMutation_ResponseAdapter.mjs.map
